module.exports = __webpack_public_path__ + "media/recipes/124-10c8a4cb.png";